/* istanbul ignore file */
import React from 'react';
import { FieldProps, LinkField, useFieldHelper } from 'framework/ui/field';
import { useOpportunityUrl } from 'domain/sales/opportunity/opportunityRouting';

const OpportunityLinkField = ({ idValue = '', idSource = undefined, ...props }: FieldProps) => {
  const { getSingleEntityUrl } = useOpportunityUrl();
  const { getValue: getId } = useFieldHelper({ source: idSource, value: idValue });
  const { getValue: getName } = useFieldHelper(props);

  const id = getId();

  return <LinkField {...props} isInternal linkText={getName()} value={getSingleEntityUrl(id)} />;
};

export default OpportunityLinkField;
